import { useEffect, useRef, useState } from "react";
import CloseButton from "./CloseButton";
import { useScore } from './context/ScoreContext';
import { getRarityFromPercentage, getRarityIcon } from "./util";

const History = ({ onClose }) => {

    const historyRef = useRef(null);
    const { day, score, gridCount, getOptionState, cs } = useScore();
    const [clicked, setClicked] = useState(false);


    useEffect(() => {
        // Ensure the div is focusable
        historyRef.current.setAttribute('tabIndex', '0');
        // Focus on the div when the component mounts
        historyRef.current.focus();
    }, []);

    const handleKeyPress = (event) => {
        if (event.key === 'Escape') {
            onClose();
        }
    };

    const handleClick = () => {
        setClicked(true);
        setTimeout(() => setClicked(false), 1000); // Message disappears after 2 seconds
    };

    let days = {};
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        const value = localStorage.getItem(key);
        const object = JSON.parse(value);
        days[key] = object;
    }


    const last7Days = {};
    for (let key in days) { // Loop through all the keys in obj
        if (key.startsWith("day") && Number(key.slice(3)) > (day - 7)) { // Check if the key starts with "day" and the number part is greater than or equal to 24
            last7Days[key] = days[key]; // Copy the key-value pair to the new object
        }
    }


    function extractNumbers(str) {
        var match = str.match(/(\d+)$/);
        return match ? parseInt(match[0], 10) : null;
    }

    const getDateString = (key) => {
        const diff = extractNumbers(key);
        if (diff === day) {
            return "Today";
        }
        if (diff === day - 1) {
            return "Yesterday";
        }
        return `Day-${diff}`;
    }

    const getShareText = async (shareDay) => {
        // Define your game details
        // console.log(cells);
        const emojis = []
        for (let i = 1; i <= 9; i++) {
            const id = i.toString();
            let slot = getOptionState(id);
            if (slot && slot['id']) {
                emojis.push(getRarityIcon(slot['id'], slot['percent']));
            } else {
                emojis.push('⬛');
            }
            if (i === 3 || i === 6) {
                emojis.push('\n');
            }
        }
        let gameTitle = `FateGrid ${day}`;
        let scoreText = `Score: ${sumArray(score)}`;
        let websiteLink = "https://fategrid.net";
        // console.log(up)
        let csText = `Command Spell Used: ${3 - cs}/3`;

        // Create the share data
        // console.log(emojis);
        let clipboardData = {
            text: `FateGrid ${day} - ${gridCount}/9\n${emojis.join('')}\n${csText}\n${websiteLink}`
        };
        let shareData = {
            title: gameTitle,
            text: `FateGrid ${day} - ${gridCount}/9\n${emojis.join('')}\n${csText}\n${websiteLink}`
        };
        // console.log(clipboardData.text);
        // Check if the Web Share API is available
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (navigator.share && isMobile) {
            try {
                await navigator.share(shareData);
                alert("Game shared successfully");
            } catch (err) {
                alert("Error sharing: " + err);
            }
        } else {

            try {
                handleClick();
                await navigator.clipboard.writeText(clipboardData.text);
                console.log("Game details copied to clipboard");
            } catch (err) {
                console.log("Error copying to clipboard: " + err);
            }
        }

    }

    const sumArray = (arr) => {
        return Math.round(arr.reduce((partialSum, a) => partialSum + a, 0));
    }
    // console.log(last7Days);
    const getGidCellColour = (day) => {
        const backgrounds = ['', '', '', '', '', '', '', '', '', ''];
        for (let i = 1; i <= 9; i++) {
            let slot = last7Days[day][i];
            // console.log(slot);
            if (slot && slot['id'] && slot['id'] > 0) {
                // backgrounds[i] = getRarityFromPercentage(slot['id'], slot['percent']);
                backgrounds[i] = "rare";
            } else if (slot && slot['id'] && slot['id'] < 0) {
                backgrounds[i] = 'wrong';
            } else {
                backgrounds[i] = 'unknown';
            }
        }
        return (<div className="score-history-container">

            <div className={`score-history-item ${backgrounds[1]}`}></div>
            <div className={`score-history-item ${backgrounds[2]}`}></div>
            <div className={`score-history-item ${backgrounds[3]}`}></div>
            <div className={`score-history-item ${backgrounds[4]}`}></div>
            <div className={`score-history-item ${backgrounds[5]}`}></div>
            <div className={`score-history-item ${backgrounds[6]}`}></div>
            <div className={`score-history-item ${backgrounds[7]}`}></div>
            <div className={`score-history-item ${backgrounds[8]}`}></div>
            <div className={`score-history-item ${backgrounds[9]}`}></div>
        </div>);
    }
    // console.log(Object.keys(last7Days));

    const listItems = Object.keys(last7Days).sort((a, b) => {
        // Extract the numeric part from the keys
        const numA = parseInt(a.replace('day', ''), 10);
        const numB = parseInt(b.replace('day', ''), 10);

        // Compare the numeric parts
        return numB - numA;
    }).map(key => (

        <li key={extractNumbers(key)}>
            <div style={{ minWidth: "7ch" }}>{getDateString(key)}:</div>

            <div className="history-list-item" style={{ width: "100%" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={`commandSpell${last7Days[key]['cs']}.png`} alt="" /> {getGidCellColour(key)}
                    {/* <span>Score : { sumArray(last7Days[key]['score'])}</span>  */}
                </div>
                {extractNumbers(key) === day &&
                    <div style={{ marginLeft: "auto" }}>
                        {clicked && <div className="copy-score-text">Copied to Clipboard!</div>}
                        <button
                            onClick={getShareText} className="score-button">🔗 Share</button> </div>}
            </div>
        </li>
    ));

    return (
        <div ref={historyRef} onKeyDown={handleKeyPress} className="history">
            <CloseButton onClose={onClose} />
            <h1>Past 7 days</h1>
            <ul>{listItems}</ul>
        </div>
    );
}

export default History;